import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		device: 'PC'
	},
	getters: {
		isPC(state) {
			return state.device === 'PC';
		}
	},
	mutations: {
		setDevice(state, data) {
			state.device = data;
		}
	}
});
